/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {useAuth} from '../../../modules/auth'
import {chooseSubscriptionPlan} from '../SettingAPI'
import Swal from 'sweetalert2'
import '../settingStyles/settingStyle.css'
import { subscriptionCardPropsDataType } from '../settingsDataType'

const SubscriptionCards: React.FC<subscriptionCardPropsDataType> = ({
  subscriptionDetails,
  selected,
  selectedPlanUUID,
  getSubscriptionPlanList,
  setLoading,
  loading
}) => {
  // {* Begin: function to choose subscription plan *}
  const choosePlan = async () => {
    setLoading(true)
    try {
      const {data: res} = await chooseSubscriptionPlan(subscriptionDetails.subscription_uuid)
      if (res.code === '200') {
        getSubscriptionPlanList()
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }
  // {* End:  function to choose subscription plan *}
  return (
    <div className={`${selected ? 'selected_subscription' : ''} `}>
      <div className={`card shadow card-xl-stretch`}>
        {/* begin::Body */}
        <div className='card-body p-0'>
          {/* Begin: selected plan heading for selected plan */}
          {selected && (
            <div
              className='d-flex justify-content-center align-items-center text-white fs-4 fw-bold rounded h-40px pb-2 w-100'
              style={{backgroundColor: 'lightgreen'}}
            >
              Selected Plan
            </div>
          )}
          {/* End: selected plan heading for selected plan */}

          {/* begin::Header */}
          <div
            className={`px-9 pt-7 card-rounded h-275px w-100 bg-primary`}
            style={{marginTop: '-10px'}}
          >
            {/* begin::Heading */}
            <div className='d-flex flex-stack mt-2 justify-content-center'>
              <h3 className='m-0 text-white fw-bold fs-1x'>
                {subscriptionDetails.subscription_name}
              </h3>
            </div>
            {/* end::Heading */}
            {/* begin::Balance */}
            <div className='d-flex text-center flex-column text-white pt-8'>
              <span className='fw-semibold fs-7'>Plan Price</span>
              <span className='fw-bold fs-2x pt-1'>₹0.00</span>
            </div>
            {/* end::Balance */}
          </div>
          {/* end::Header */}
          {/* begin::Items */}
          <div
            className='shadow-xs card-rounded mx-9 mb-7 px-6 py-9 position-relative z-index-1 bg-body'
            style={{marginTop: '-100px'}}
          >
            {/* begin::Item */}
            <div className='d-flex align-items-center mb-6'>
              {/* begin::Symbol */}
              <div className='symbol symbol-45px w-40px me-5'>
                <span className='symbol-label bg-lighten'>
                  <i className='bi bi-house-door svg-icon-1 fs-1 text-muted'></i>
                </span>
              </div>
              {/* end::Symbol */}
              {/* begin::Description */}
              <div className='d-flex align-items-center flex-wrap w-100'>
                {/* begin::Title */}
                <div className='mb-1 pe-3 flex-grow-1'>
                  <a href='#' className='fs-5 text-gray-800 text-hover-primary fw-bold'>
                    Properties
                  </a>
                  <div className='text-gray-400 fw-semibold fs-7'>{`${subscriptionDetails.allowed_subscription_free_property_count} Properties`}</div>
                </div>
                {/* end::Title */}
              </div>
              {/* end::Description */}
            </div>
            {/* end::Item */}
            {/* begin::Item */}
            <div className='d-flex align-items-center mb-6'>
              {/* begin::Symbol */}
              <div className='symbol symbol-45px w-40px me-5'>
                <span className='symbol-label bg-lighten'>
                  <i
                    className='bi bi-people-fill svg-icon-1 fs-1 text-muted'
                    title='Property Users'
                  ></i>
                </span>
              </div>
              {/* end::Symbol */}
              {/* begin::Description */}
              <div className='d-flex align-items-center flex-wrap w-100'>
                {/* begin::Title */}
                <div className='mb-1 pe-3 flex-grow-1'>
                  <a href='#' className='fs-5 text-gray-800 text-hover-primary fw-bold'>
                    Users
                  </a>
                  <div className='text-gray-400 fw-semibold fs-7'>{`${subscriptionDetails.allowed_user_count} Users`}</div>
                </div>
                {/* end::Title */}
              </div>
              {/* end::Description */}
            </div>
            {/* end::Item */}
            {/* begin::Item */}
            <div className='d-flex align-items-center'>
              {/* begin::Symbol */}
              <div className='symbol symbol-45px w-40px me-5'>
                <span className='symbol-label bg-lighten'>
                  <i className='bi bi-person-fill svg-icon-1 fs-1 text-muted'></i>
                </span>
              </div>
              {/* end::Symbol */}
              {/* begin::Description */}
              <div className='d-flex align-items-center flex-wrap w-100'>
                {/* begin::Title */}
                <div className='mb-1 pe-3 flex-grow-1'>
                  <a href='#' className='fs-5 text-gray-800 text-hover-primary fw-bold'>
                    Account
                  </a>
                  <div className='text-gray-400 fw-semibold fs-7'>{`${subscriptionDetails.allowed_admin_count} Admin accounts`}</div>
                </div>
                {/* end::Title */}
              </div>
              {/* end::Description */}
            </div>
            {/* end::Item */}
          </div>
          {/* end::Items */}
        </div>
        {/* Begin: choose button if plan is not selected */}
        {!selectedPlanUUID && (
          <div className='d-flex justify-content-center pb-5'>
            <button
              className='btn btn-sm fw-bold btn-primary fs-7'
              onClick={choosePlan}
              disabled={loading}
            >
              Choose
            </button>
          </div>
        )}
        {/* End: choose button if plan is not selected */}
        {/* end::Body */}
      </div>
    </div>
  )
}

export default SubscriptionCards
